export enum EAccountCategory{
    NotMentioned = 0,
    Commercial = 1,
    Custom = 2
}